import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Tooltip, TextField, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';
import "../doctor/components/allpages.css";
// import path from "../../path";

const WebHookModal = ({ openWebHook, handleClose, provider, webhookUrl }) => {

  // const webhookBaseUrl = webhookUrl;
  // const webhookLink = `${path}/v1/url/A12b3C4dEf?providerId=${provider?.location_id}`;

  const baseLink = process.env.REACT_APP_BVDQ_URL;

  const queryParams = new URLSearchParams();

  [
    ['link', provider?.website],
    ['locationId', provider?.location_id],
    ['providerId', provider?.id]
  ].forEach(([key, value]) => {
    if (value) queryParams.append(key, value);
  });


  const webhookLink = `${baseLink}?${queryParams.toString()}`;


  const handleCopy = () => {
    if (provider?.id) {
      navigator.clipboard.writeText(webhookLink);
      toast.success("Webhook URL copied to clipboard!");
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="webhook-dialog-title"
      open={openWebHook}
    >
      <div className="d-flex align-items-center justify-content-between">
        <DialogTitle id="customized-dialog-title">
          NVM Location Webhook
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent dividers>
        <div className="d-flex align-items-center justify-content-between">
          <div className="webhook-container">

            <div className="row">
              <div className="col-lg-12 col-sm-12">
                <div className="formdesign">
                  {provider?.id && (
                    <TextField
                      fullWidth
                      className="notesblock"
                      label="Webhook URL"
                      value={webhookLink}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title="Copy to clipboard" placement="top" arrow>
                              <IconButton onClick={handleCopy}>
                                <ContentCopyIcon />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WebHookModal;
